var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-padding" },
    [
      _c(
        "div",
        {
          staticClass: "spaceBetween",
          staticStyle: { "margin-bottom": "0.24rem" },
        },
        [
          _c("div", { staticClass: "spaceLeft" }, [
            _c("div", { staticClass: "detail-title-1" }, [
              _vm._v("My proposal"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "spaceLeft start-vote",
                on: { click: _vm.toCreate },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/image/governance/start-vote.png"),
                  },
                }),
                _vm._v("\n        Initiate Proposal\n      "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "spaceLeft search-form" }, [
            _c(
              "div",
              { staticClass: "sapceLeft search-item" },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "No...",
                    "suffix-icon": "el-icon-search",
                  },
                  on: { change: _vm.getList },
                  model: {
                    value: _vm.searchParams.id,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParams, "id", $$v)
                    },
                    expression: "searchParams.id",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-card is-border" }, [
        _c(
          "div",
          { staticClass: "common-card-main" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "common-table",
                attrs: { data: _vm.tableList },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "Proposal No." },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            "\n            No." +
                              _vm._s(row.id) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "title", label: "Title" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "vote",
                    label: "Current Votes",
                    align: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("big-number", {
                            attrs: { number: row.totalWeight },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "day" }, [_vm._v("UNIT")]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "startBlock",
                    label: "Start Block",
                    align: "center",
                    minWidth: "140",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "Duration", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.duration.toString(),
                                placement: "top",
                              },
                            },
                            [
                              _c("p", { staticClass: "duration" }, [
                                _vm._v(_vm._s(_vm.duration.toFixed(4)) + " "),
                                _c("span", { staticClass: "day" }, [
                                  _vm._v("Day"),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "status", label: "Proposal Status" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("vote-status-td-comp", {
                            attrs: { status: row.status },
                            on: {
                              "update:status": function ($event) {
                                return _vm.$set(row, "status", $event)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "executeStatus", label: "Execution Status" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          [1, 4, 5].includes(row.status)
                            ? _c("span", { staticClass: "status" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/image/governance/icon8.png"),
                                    alt: "",
                                  },
                                }),
                                _vm._v("Not executed\n            "),
                              ])
                            : [2, 3, 6, 7, 8].includes(row.status)
                            ? _c("span", { staticClass: "status" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/image/governance/icon5.png"),
                                    alt: "",
                                  },
                                }),
                                _vm._v("Executed\n            "),
                              ])
                            : _c("span", { staticClass: "status" }, [
                                _vm._v("--"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "operation", label: "Operation" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.toDetail(row)
                                },
                              },
                            },
                            [_vm._v("Details")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              attrs: {
                total: _vm.queryParams.total,
                page: _vm.queryParams.page,
                limit: _vm.queryParams.pageSize,
              },
              on: {
                "update:total": function ($event) {
                  return _vm.$set(_vm.queryParams, "total", $event)
                },
                "update:page": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.queryParams, "pageSize", $event)
                },
                pagination: function ($event) {
                  return _vm.getList()
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("extractDialog", {
        ref: "extractDialog",
        on: { success: _vm.refresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }